export default "__VITE_ASSET__CmYhdNlk__"